var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "margin-top": "40px",
      "margin-left": "40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n        签约项目管理-" + _vm._s(_vm.form.id != null && _vm.form.id != '' ? '修改' : '新增') + "\n    ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "#FFFFFF",
      "margin": "0px 40px",
      "margin-top": "9px",
      "padding-top": "30px",
      "overflow-x": "hidden"
    }
  }, [_vm._m(0), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-left": "30px",
      "margin-right": "30px",
      "margin-top": "20px",
      "margin-bottom": "30px"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "190px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "0 10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.id != null && _vm.form.id != ''),
      expression: "form.id != null && form.id != ''"
    }],
    attrs: {
      "label": "组织架构",
      "prop": "organize_ids"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #DCDFE6",
      "width": "75%",
      "border-radius": "5px",
      "padding-left": "10px",
      "padding-right": "10px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$globals.group_name + "/" + _vm.form.organize_name) + "\n                        ")])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.id === null || _vm.form.id === ''),
      expression: "form.id === null || form.id === ''"
    }],
    attrs: {
      "label": "组织架构",
      "prop": "organize_ids"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "collapse-tags": "",
      "props": _vm.props
    },
    on: {
      "change": _vm.changeCascader
    },
    model: {
      value: (_vm.form.organize_temporary_ids),
      callback: function($$v) {
        _vm.$set(_vm.form, "organize_temporary_ids", $$v)
      },
      expression: "form.organize_temporary_ids"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "城市",
      "prop": "city"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.form.city),
      callback: function($$v) {
        _vm.$set(_vm.form, "city", $$v)
      },
      expression: "form.city"
    }
  }, _vm._l((_vm.$globals.cityList), function(item) {
    return _c('el-option', {
      key: item.city,
      attrs: {
        "label": item.city,
        "value": item.city
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "甲方名头",
      "prop": "party_title"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入甲方名头"
    },
    model: {
      value: (_vm.form.party_title),
      callback: function($$v) {
        _vm.$set(_vm.form, "party_title", $$v)
      },
      expression: "form.party_title"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "乙方名头",
      "prop": "spare6"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.form.spare6),
      callback: function($$v) {
        _vm.$set(_vm.form, "spare6", $$v)
      },
      expression: "form.spare6"
    }
  }, _vm._l((_vm.$parent.partnerList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.partner_abbreviation,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同编码",
      "prop": "contract_code"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入合同编码"
    },
    model: {
      value: (_vm.form.contract_code),
      callback: function($$v) {
        _vm.$set(_vm.form, "contract_code", $$v)
      },
      expression: "form.contract_code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同名称",
      "prop": "contract_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入合同名称"
    },
    model: {
      value: (_vm.form.contract_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "contract_name", $$v)
      },
      expression: "form.contract_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "业务系列",
      "prop": "series_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.form.series_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "series_id", $$v)
      },
      expression: "form.series_id"
    }
  }, _vm._l((_vm.seriesList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "业务板块",
      "prop": "andInnovation_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.form.andInnovation_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "andInnovation_id", $$v)
      },
      expression: "form.andInnovation_id"
    }
  }, _vm._l((_vm.andInnovationList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同开始时间",
      "prop": "contract_start_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.form.contract_start_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "contract_start_date", $$v)
      },
      expression: "form.contract_start_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同结束时间",
      "prop": "contract_end_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.form.contract_end_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "contract_end_date", $$v)
      },
      expression: "form.contract_end_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同核算单位",
      "prop": "contract_unit"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "change": _vm.ContractUnitOperate
    },
    model: {
      value: (_vm.form.contract_unit),
      callback: function($$v) {
        _vm.$set(_vm.form, "contract_unit", $$v)
      },
      expression: "form.contract_unit"
    }
  }, _vm._l((_vm.contractUnitList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "服务费核算标准",
      "prop": "service_charge_standard"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.form.service_charge_standard),
      callback: function($$v) {
        _vm.$set(_vm.form, "service_charge_standard", $$v)
      },
      expression: "form.service_charge_standard"
    }
  }, _vm._l((_vm.serviceChargeStandardList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目名称",
      "prop": "project_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入项目名称"
    },
    model: {
      value: (_vm.form.project_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "project_name", $$v)
      },
      expression: "form.project_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目地址",
      "prop": "project_site"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入项目地址"
    },
    model: {
      value: (_vm.form.project_site),
      callback: function($$v) {
        _vm.$set(_vm.form, "project_site", $$v)
      },
      expression: "form.project_site"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.contract_headcount_label,
      "prop": "contract_headcount"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.contract_headcount_placeholder
    },
    model: {
      value: (_vm.form.contract_headcount),
      callback: function($$v) {
        _vm.$set(_vm.form, "contract_headcount", $$v)
      },
      expression: "form.contract_headcount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.contract_min_count_label,
      "prop": "contract_min_count"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.contract_min_count_placeholder
    },
    model: {
      value: (_vm.form.contract_min_count),
      callback: function($$v) {
        _vm.$set(_vm.form, "contract_min_count", $$v)
      },
      expression: "form.contract_min_count"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同要求每日每人最多工时",
      "prop": "contract_max_labor_hour"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入合同要求每日每人最多工时"
    },
    model: {
      value: (_vm.form.contract_max_labor_hour),
      callback: function($$v) {
        _vm.$set(_vm.form, "contract_max_labor_hour", $$v)
      },
      expression: "form.contract_max_labor_hour"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同要求每日最少工时",
      "prop": "contract_min_day_labor_hour"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入合同要求每日最少工时"
    },
    model: {
      value: (_vm.form.contract_min_day_labor_hour),
      callback: function($$v) {
        _vm.$set(_vm.form, "contract_min_day_labor_hour", $$v)
      },
      expression: "form.contract_min_day_labor_hour"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同要求每月最少工时",
      "prop": "contract_min_month_labor_hour"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入合同要求每月最少工时"
    },
    model: {
      value: (_vm.form.contract_min_month_labor_hour),
      callback: function($$v) {
        _vm.$set(_vm.form, "contract_min_month_labor_hour", $$v)
      },
      expression: "form.contract_min_month_labor_hour"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否使用客户要求",
      "prop": "is_client_require"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.form.is_client_require),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_client_require", $$v)
      },
      expression: "form.is_client_require"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.form.is_client_require),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_client_require", $$v)
      },
      expression: "form.is_client_require"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "月度合同金额",
      "prop": "monthly_contract_amount"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入月度合同金额"
    },
    model: {
      value: (_vm.form.monthly_contract_amount),
      callback: function($$v) {
        _vm.$set(_vm.form, "monthly_contract_amount", $$v)
      },
      expression: "form.monthly_contract_amount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代发公司",
      "prop": "agency_company"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.form.agency_company),
      callback: function($$v) {
        _vm.$set(_vm.form, "agency_company", $$v)
      },
      expression: "form.agency_company"
    }
  }, _vm._l((_vm.causeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "撤场日期",
      "prop": "withdrawal_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.form.withdrawal_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "withdrawal_date", $$v)
      },
      expression: "form.withdrawal_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "进场日期",
      "prop": "mobilization_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.form.mobilization_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobilization_date", $$v)
      },
      expression: "form.mobilization_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "结算方式",
      "prop": "settlement_method"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "change": _vm.ContractUnitOperate
    },
    model: {
      value: (_vm.form.settlement_method),
      callback: function($$v) {
        _vm.$set(_vm.form, "settlement_method", $$v)
      },
      expression: "form.settlement_method"
    }
  }, _vm._l((_vm.methodList), function(item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": item.label,
        "value": item.label
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "预算定额人数",
      "prop": "budget_quota_number"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入预算定额人数"
    },
    model: {
      value: (_vm.form.budget_quota_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "budget_quota_number", $$v)
      },
      expression: "form.budget_quota_number"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "年度合同收入",
      "prop": "annual_contract_revenue"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入年度合同收入"
    },
    model: {
      value: (_vm.form.annual_contract_revenue),
      callback: function($$v) {
        _vm.$set(_vm.form, "annual_contract_revenue", $$v)
      },
      expression: "form.annual_contract_revenue"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物料定额",
      "prop": "material_quota"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入物料定额"
    },
    model: {
      value: (_vm.form.material_quota),
      callback: function($$v) {
        _vm.$set(_vm.form, "material_quota", $$v)
      },
      expression: "form.material_quota"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "工资定额",
      "prop": "wage_quota"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入工资定额"
    },
    model: {
      value: (_vm.form.wage_quota),
      callback: function($$v) {
        _vm.$set(_vm.form, "wage_quota", $$v)
      },
      expression: "form.wage_quota"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "打卡参考地点照片"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "show-file-list": false,
      "on-success": _vm.handleBankPhotoSuccess
    }
  }, [(_vm.form.clock_in_reference_location) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.clock_in_reference_location
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), (_vm.form.id != null && _vm.form.id != '') ? _c('el-form-item', {
    staticStyle: {
      "padding": "0 10%"
    },
    attrs: {
      "label": "合同单价:"
    }
  }, _vm._l((_vm.form.contractCount), function(item, index) {
    return _c('el-row', {
      key: index,
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', [_c('el-input', {
      staticStyle: {
        "width": "98%"
      },
      model: {
        value: (_vm.form.contractList[index].contract_price),
        callback: function($$v) {
          _vm.$set(_vm.form.contractList[index], "contract_price", $$v)
        },
        expression: "form.contractList[index].contract_price"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((index + 1) == _vm.form.contractCount.length),
        expression: "(index + 1) == form.contractCount.length"
      }],
      attrs: {
        "src": require("../../../assets/icon/添加.png"),
        "width": "20px"
      },
      on: {
        "click": function($event) {
          return _vm.shiftAdd(index)
        }
      }
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index != 0),
        expression: "index != 0"
      }],
      attrs: {
        "src": require("../../../assets/icon/减少.png"),
        "width": "20px"
      },
      on: {
        "click": function($event) {
          return _vm.shiftRemove(index)
        }
      }
    })])], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.id == null || _vm.form.id == ''),
      expression: "form.id == null || form.id == ''"
    }],
    staticStyle: {
      "background-color": "#006E4B",
      "border": "1px #006E4B solid",
      "width": "120px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.id != null && _vm.form.id != ''),
      expression: "form.id != null && form.id != ''"
    }],
    staticStyle: {
      "background-color": "#006E4B",
      "border": "1px #006E4B solid",
      "width": "120px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Update
    }
  }, [_vm._v("修改")])], 1)], 1)], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border-left": "3px #006E4B solid",
      "height": "20px",
      "width": "100%",
      "margin-left": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px",
      "font-size": "20px",
      "line-height": "20px",
      "font-weight": "bold"
    }
  }, [_vm._v("项目基础信息")])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f6d4516","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/znpb/QyxmGl/QyxmGl_add.vue
// module id = null
// module chunks = 